import Vue from 'vue';
import Rir from '@rir/vue-library';
// import '@rir/vue-library/dist/RirLib.css';
// import Rir from './vue-library/RirLib.umd.min';
// import './vue-library/RirLib.css';
Vue.use(Rir);

const options = {};
export default new Rir(options);
